import { render, staticRenderFns } from "./PopupCookies.vue?vue&type=template&id=7de677ce&"
import script from "./PopupCookies.vue?vue&type=script&lang=js&"
export * from "./PopupCookies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports